import { Directive, HostBinding, Input, ViewContainerRef } from '@angular/core';
import { NgModel } from '@angular/forms';
import { MessageProps, messageStyles } from '@kite_aerolab/shared/components';

@Directive({
  selector: '[kiteMessage]',
  providers: [NgModel],
})
export class MessageDirective {
  @Input() type: MessageProps['type'];
  @Input() css: MessageProps['css'];

  constructor(public viewContainerRef: ViewContainerRef) {}

  @HostBinding('class')
  public get isError(): string {
    return this.type === 'error'
      ? messageStyles({ type: 'error', css: this.css }).className
      : messageStyles({ css: this.css }).className;
  }
}
